export default "__VITE_ASSET__DmhfO1C9__"